const onboarding = {
	state: () => ({
		onboarding: false,
		showModalUsageReason: false,
		showModalDocumentStyle: false,
		showPopoverBankDetails: false,
		showPopoverCompany: false,
		showPopoverLogo: false,
		showPopoverNumbering: false,
		showPopoverPayment: false,
		showPopoverEndOnboarding: false,
		popovers: {
			showModalDocumentStyle: false,
			showPopoverLogo: false,
			showPopoverNumbering: false,
			showPopoverCompany: false,
			showPopoverPayment: false,
			showPopoverBankDetails: false,
			showPopoverEndOnboarding: false
		},
		total_popovers_to_show: 0,
		current_popover_showed: 1,
        showModalDocumentStyleCloseButton: false

	}),
	mutations: {
        popovers(state, { key, value}) {
            state.popovers[key] = value;
        },
		onboarding(state, payload) {
			state.onboarding = payload;
		},
		showModalUsageReason(state, payload) {
			state.showModalUsageReason = payload;
		},
		showModalDocumentStyle(state, payload) {
			state.showModalDocumentStyle = payload;
		},
		showPopoverBankDetails(state, payload) {
			state.showPopoverBankDetails = payload;
		},
		showPopoverCompany(state, payload) {
			state.showPopoverCompany = payload;
		},
		showPopoverLogo(state, payload) {
			state.showPopoverLogo = payload;
		},
		showPopoverNumbering(state, payload) {
			state.showPopoverNumbering = payload;
		},
		showPopoverPayment(state, payload) {
			state.showPopoverPayment = payload;
		},
		showPopoverEndOnboarding(state, payload) {
			state.showPopoverEndOnboarding = payload;
		},
		setPopovers(state, { key, value }) {
			state.popovers[key] = value;
		},
		setTotalPopoversToShow(state, payload) {
			state.total_popovers_to_show = payload;
		},
		setCurrentPopoverShowed(state, payload) {
			state.current_popover_showed = payload;
		},
        showModalDocumentStyleCloseButton(state, payload) {
            state.showModalDocumentStyleCloseButton = payload;
        }
	},
	getters: {},
	actions: {
		setNextOpenedPopover({ commit, state }) {
			// get next fragment set to true
			const nextPopover = Object.keys(state.popovers).find(key => state.popovers[key] === true);
			if (nextPopover) {
				commit(nextPopover, true);
			}
		},
		computeTotalPopoversToShow({ commit, state }) {
			const countable_modals = [
				"showPopoverLogo",
				"showPopoverNumbering",
				"showPopoverCompany",
				"showPopoverPayment",
				"showPopoverBankDetails"
			];
			let total_popovers_to_show = 0;
			for (let modal of countable_modals) {
				if (state.popovers[modal] === true) {
					total_popovers_to_show++;
				}
			}
			commit("setTotalPopoversToShow", total_popovers_to_show);
		},
		incrementCurrentPopoverShowed({ commit, state }) {
			commit("setCurrentPopoverShowed", state.current_popover_showed + 1);
		}
	}
};

export default onboarding;
